<template>
  <GmapMap :options="{
                    streetViewControl: false,
                    mapTypeControl: false,
                    zoomControl: false,
                    fullscreenControl: false,
                    gestureHandling : 'none',}" :center="{lat:store.lat, lng:store.lng}" :zoom="16"
           map-type-id="terrain">
    <GmapMarker :clickable="false" :draggable="false" :position="{lat:store.lat, lng:store.lng}"/>
  </GmapMap>
</template>

<script>
  export default {
    name: "FullScreenMap",
    props: ['store']
  }
</script>

<style scoped lang="scss">
  .vue-map-container {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 60vh;
  }
</style>



// WEBPACK FOOTER //
// src/Elements/FullScreenMap.vue